import { Dictionary } from 'lodash';
import moment from 'moment';
import { User } from 'api/models';
import { TimeoffResponse } from 'api/timeoff/types';
import { getSchedulerEventProps } from 'components/organisms/resource-management/utils/events-conversion/common';
import {
  idForTimeoffAsSummaryEvent,
  resourceIdForUser,
} from 'components/organisms/resource-management/utils/id';
import { SchedulerEventType, TimeOffEvent } from '../../../event-types';
import { SchedulerResourceType } from '../../../resource-types';

const TimeoffAsSummaryEvent = (
  userId: number,
  timeOff: TimeoffResponse,
): TimeOffEvent => {
  return {
    type: SchedulerEventType.UserTimeOff,
    id: idForTimeoffAsSummaryEvent(userId, timeOff.timeOffId),
    startDate: moment(timeOff.timeOffStart).startOf('day').toDate(),
    endDate: moment(timeOff.timeOffEnd).endOf('day').toDate(),
    timeOff,
    ...getSchedulerEventProps(SchedulerEventType.UserTimeOff, {
      cls: 'time-off-event',
    }),
    userId,
    resourceId: resourceIdForUser(userId),
  };
};

export const convertTimeOffAsSummaryEvents = (
  userLookup: Dictionary<User>,
  schedulerRef: React.MutableRefObject<any>,
): TimeOffEvent[] => {
  const rawTimeOffEvents: TimeOffEvent[] = [];

  schedulerRef.current.instance.resourceStore.records.forEach((resource) => {
    if (
      resource != null &&
      resource.get('type') === SchedulerResourceType.User
    ) {
      userLookup[resource?.userId]?.userTimeOffDetails?.forEach((timeoff) => {
        rawTimeOffEvents.push(
          TimeoffAsSummaryEvent(Number(resource.userId), timeoff),
        );
      });
    }
  });

  return rawTimeOffEvents;
};
